import { paginatedTransform } from 'src/services/skuit/utils'
import { PaginatedResponse, Product } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export class Products {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Product>> => {
    const response = await this.api.get('/logistics/products', config)
    return paginatedTransform(Product)(response.data)
  }
}
